// extracted by mini-css-extract-plugin
export default {"menuHeader":"styles_menuHeader__rMMz7","menuContent":"styles_menuContent__gYyqJ","userInfo":"styles_userInfo__RV0hV","logo":"styles_logo__Wrypc"};